import { 
  Star, Rocket, Heart, Sun, Crown, Sparkles, 
  Flower2, Cat, Fish, Bird, Bug, TreePine 
} from 'lucide-react';

export const AVATARS = [
  { id: 'star', icon: Star, gradient: 'from-amber-400 to-orange-500', label: 'Star' },
  { id: 'rocket', icon: Rocket, gradient: 'from-blue-400 to-indigo-500', label: 'Rocket' },
  { id: 'heart', icon: Heart, gradient: 'from-pink-400 to-rose-500', label: 'Heart' },
  { id: 'sun', icon: Sun, gradient: 'from-yellow-400 to-amber-500', label: 'Sun' },
  { id: 'crown', icon: Crown, gradient: 'from-emerald-400 to-green-500', label: 'Crown' },
  { id: 'sparkles', icon: Sparkles, gradient: 'from-purple-400 to-violet-500', label: 'Magic' },
  { id: 'flower', icon: Flower2, gradient: 'from-rose-400 to-pink-500', label: 'Flower' },
  { id: 'cat', icon: Cat, gradient: 'from-orange-400 to-red-400', label: 'Cat' },
  { id: 'fish', icon: Fish, gradient: 'from-cyan-400 to-blue-500', label: 'Fish' },
  { id: 'bird', icon: Bird, gradient: 'from-teal-400 to-emerald-500', label: 'Bird' },
  { id: 'bug', icon: Bug, gradient: 'from-lime-400 to-green-500', label: 'Bug' },
  { id: 'tree', icon: TreePine, gradient: 'from-green-500 to-emerald-600', label: 'Tree' },
];

export function getAvatarById(id) {
  return AVATARS.find(a => a.id === id) || AVATARS[0];
}

export function AvatarDisplay({ avatarId, size = 'md', name = '' }) {
  const avatar = getAvatarById(avatarId);
  const Icon = avatar.icon;
  
  const sizes = {
    sm: { container: 'w-10 h-10', icon: 'w-5 h-5' },
    md: { container: 'w-16 h-16', icon: 'w-8 h-8' },
    lg: { container: 'w-24 h-24', icon: 'w-12 h-12' },
  };
  
  const s = sizes[size] || sizes.md;
  
  if (!avatarId) {
    return (
      <div className={`${s.container} bg-gradient-to-br from-orange-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold shadow-lg`}>
        <span className={size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-sm' : 'text-2xl'}>
          {name?.charAt(0)?.toUpperCase() || '?'}
        </span>
      </div>
    );
  }
  
  return (
    <div className={`${s.container} bg-gradient-to-br ${avatar.gradient} rounded-full flex items-center justify-center shadow-lg`}>
      <Icon className={`${s.icon} text-white`} />
    </div>
  );
}
